import React, { Component } from 'react';
import NavBar from './components/NavBar';
//import loginRequest from './config';
import { msalConfig, tokenRequest, loginRequest, graphConfig } from './config';
import moment from 'moment';
import qs from 'qs';
//import { UserAgentApplication } from 'msal';
import {myMSALObj,entityList,functionList,entityMap,frequencyList,languageList,organizationMap,userGuidMap,environmentSetUp,environmentSelection} from './components/Configurations'
//import {myMSALObj,requestOptions,proxyUrl,tokenUrl,searchRequestOptions,detailsBaseUrl,esbRequestOptions,entityList,sensitivityLevelList,organizationList,organizationIDList,functionList,entityMap,functionMap, frequencyList, languageList,organizationMap,userGuidMap,restrictedEntities,environmentSetUp,environmentSelection} from './components/Configurations'
//import {OAuth2} from 'fetch-mw-oauth2'
import Calendar from 'react-calendar';
//import { AccessTokenCacheItem } from 'msal/lib-commonjs/cache/AccessTokenCacheItem';
import $ from "jquery"


let availableTermGuid = []

class Edit extends Component{

    constructor(props){
        super(props)
        this.state={
            keyword:"",
            toggle:true,
            availableGlossaryTerms:[],
            guid:"",
            accessToken:sessionStorage.getItem("accessToken"),
            expiresOn:sessionStorage.getItem("expiresOn"),
            details:undefined,
            name:"",
            technicalName:"",
            description:"",
            entityID:"",
            entityName:"",
            organizationID:"",
            organizationName:"",
            sensitivityLevel:"",
            linkToData:"",
            startDate:"",
            closeDate:"",
            updatedOn:"",
            pii:"",
            status:"",
            updatedBy:"",
            isPublic:false,
            isUnclassified:false,
            isConfidential:false,
            isStrictlyConfidential:false,
            expert:"",
            expertEmail:"",
            owner:"",
            function:"",
            frequency:"",
            language:"",
            databaseManagementSystem:"",
            qualifiedName:"",
            glossaryTerms:[],
            showStartDateCalendar:false,
            showCloseDateCalendar:false,
            showUpdatedOnCalendar:false,
            currentRelationshipId:"",
            loadMoreClicked:false
        }
        this.handleLogOut = this.handleLogOut.bind(this); 
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeTechnicalName = this.handleChangeTechnicalName.bind(this);
        this.handleChangeDescription = this.handleChangeDescription.bind(this);
        this.handleClickPublic = this.handleClickPublic.bind(this);
        this.handleClickUnclassified = this.handleClickUnclassified.bind(this);
        this.handleClickConfidential = this.handleClickConfidential.bind(this);
        this.handleClickStrictlyConfidential = this.handleClickStrictlyConfidential.bind(this);
        this.handleChangeLinkToData = this.handleChangeLinkToData.bind(this);
        this.handleChangeExpert = this.handleChangeExpert.bind(this);
        this.handleChangeOwner = this.handleChangeOwner.bind(this);
        this.handleChangeUpdatedBy = this.handleChangeUpdatedBy.bind(this);
        this.handleClickEntity = this.handleClickEntity.bind(this);
        this.handleSaveChanges = this.handleSaveChanges.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClickOrganization = this.handleClickOrganization.bind(this);
        this.handleChangePII = this.handleChangePII.bind(this);
        this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
        this.handleChangeCloseDate = this.handleChangeCloseDate.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.handleClickFunction = this.handleClickFunction.bind(this);
        this.handleClickFrequency = this.handleClickFrequency.bind(this);
        this.handleClickLanguage = this.handleClickLanguage.bind(this);
        this.handleChangeDatabaseManagementSystem = this.handleChangeDatabaseManagementSystem.bind(this);
        this.handleDeleteEntry = this.handleDeleteEntry.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDeleteTerm = this.handleDeleteTerm.bind(this);
        this.handleAddTerm = this.handleAddTerm.bind(this);
        this.handleClickInfo = this.handleClickInfo.bind(this);
    }

    handleCreate(){
        this.props.history.push({
            pathname:'/create'
        })
    }

    handleCancel(){
        this.props.history.push({
            pathname:"/details",
            search:"guid="+this.state.guid,
            state:{guid:this.state.guid}
        })
    }

    handleLogOut(){
        sessionStorage.setItem('user','');
        sessionStorage.setItem('email','');
        sessionStorage.setItem('keyword','');
        sessionStorage.setItem('accessToken','');
        sessionStorage.setItem('expiresOn','');
        sessionStorage.setItem('role','');
        this.props.history.push('/logout');
        myMSALObj.logout();
        
      }

    handleChangeName(event){
        this.setState({ 
            name: event.target.value
          });
    }

    handleChangeTechnicalName(event){
        this.setState({
            technicalName:event.target.value
        })
    }

    handleChangeDescription(event){
        this.setState({
            description:event.target.value
        })
    }

    handleChangeLinkToData(event){
        this.setState({
            linkToData:event.target.value
        })
    }

    handleClickPublic(){
        this.setState({
            isPublic:true,
            isUnclassified:false,
            isConfidential:false,
            isStrictlyConfidential:false,
            sensitivityLevel:"PUBLIC"   
        })
    }

    handleClickUnclassified(){
        this.setState({
            isPublic:false,
            isUnclassified:true,
            isConfidential:false,
            isStrictlyConfidential:false,
            sensitivityLevel:"UNCLASSIFIED"   
        })
    }

    handleClickConfidential(){
        this.setState({
            isPublic:false,
            isUnclassified:false,
            isConfidential:true,
            isStrictlyConfidential:false,
            sensitivityLevel:"CONFIDENTIAL"
        })
    }

    handleClickStrictlyConfidential(){
        this.setState({
            isPublic:false,
            isUnclassified:false,
            isConfidential:false,
            isStrictlyConfidential:true,
            sensitivityLevel:"STRICTLY CONFIDENTIAL"  
        })
    }

    handleChangeExpert(event){
        this.setState({
            expert:event.target.value
        })
    }

    handleChangeOwner(event){
        this.setState({
            owner:event.target.value
        })
    }

    handleChangeUpdatedBy(event){
        this.setState({
            updatedBy:event.target.value
        })
    }

    handleClickEntity(event){
        this.setState({
            entityID:event.target.value,
            entityName:entityMap[event.target.value]
        })
    }

    handleClickOrganization(event){
        this.setState({
            organizationName:event.target.value,
            organizationID:organizationMap[event.target.value]
        })
    }

    handleChangePII(event){
        this.setState({
            pii:event.target.value
        })
    }

    handleChangeStartDate(date){
        this.setState({
            startDate:date,
            showStartDateCalendar:false
            })
    }

    handleChangeCloseDate(date){
        this.setState({
            closeDate:date,
            showCloseDateCalendar:false
            })
    }

    handleChangeStatus(event){
        this.setState({
            status:event.target.value
        })
    }

    handleClickFunction(event){
        this.setState({
            function:event.target.value
        })
    }

    handleClickFrequency(event){
        this.setState({
            frequency:event.target.value
        })
    }

    handleClickLanguage(event){
        this.setState({
            language:event.target.value
        })
    }

    handleChangeDatabaseManagementSystem(event){
        this.setState({
            databaseManagementSystem:event.target.value
        })
    }

    handleClickInfo(){
        this.setState({loadMoreClicked:!this.state.loadMoreClicked}) 
    }


    async handleAddTerm(event){
        console.log(event.target.value)
        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            console.log("token is bad");
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp["purviewAccessToken"][environmentSelection])
            const data = await res.json();
            console.log('the new code');
            var currentDateTime = new Date();
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                sessionStorage.setItem('accessToken',this.state.accessToken);
                sessionStorage.setItem('expiresOn',this.state.expiresOn);
                // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/terms/"+$("#pick-glossary-term option:selected").attr("id")+"/assignedEntities",{
                fetch(environmentSetUp["addGlossaryTermsBaseUrl"][environmentSelection]+$("#pick-glossary-term option:selected").attr("id")+"/assignedEntities",{
                    method:"POST",
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    },
                    body:JSON.stringify([{
                        "guid":this.state.guid
                    }])
                }).then(alert("The glossary term has been added, please refresh the page."))
            })
        }else{
            sessionStorage.setItem('accessToken',this.state.accessToken);
            sessionStorage.setItem('expiresOn',this.state.expiresOn);
            // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/terms/"+$("#pick-glossary-term option:selected").attr("id")+"/assignedEntities",{
            fetch(environmentSetUp["addGlossaryTermsBaseUrl"][environmentSelection]+$("#pick-glossary-term option:selected").attr("id")+"/assignedEntities",{
                method:"POST",
                headers:{
                    'Authorization':'Bearer ' + this.state.accessToken,
                    'Content-Type': 'application/json'
                },
                body:JSON.stringify([{
                    "guid":this.state.guid
                }])
            }).then(alert("The glossary term has been added, please refresh the page."))
        }
    }

    async handleDeleteTerm(event){
        let selectedTermGuid = event.target.id
        console.log("clicked delete term")
        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            console.log("token is bad");
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp["purviewAccessToken"][environmentSelection])
            const data = await res.json();
            var currentDateTime = new Date();
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                sessionStorage.setItem('accessToken',this.state.accessToken);
                sessionStorage.setItem('expiresOn',this.state.expiresOn);
                let i;
                for(i=0;i<this.state.glossaryTerms.length;i++){
                    if (this.state.glossaryTerms[i]["guid"] === selectedTermGuid){
                        this.setState({currentRelationshipId:this.state.glossaryTerms[i]["relationshipGuid"]},()=>{
                            // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/terms/"+selectedTermGuid+"/assignedEntities",{
                            fetch(environmentSetUp["deleteGlossaryTermsBaseUrl"][environmentSelection] +selectedTermGuid+"/assignedEntities",{
                                method:"DELETE",
                                headers:{
                                    'Authorization':'Bearer ' + this.state.accessToken,
                                    'Content-Type': 'application/json'
                                },
                                body:JSON.stringify([{
                                    "guid":this.state.guid,
                                    "relationshipGuid":this.state.currentRelationshipId
                                }])
                            }).then(alert("The glossary term has been deleted, please refresh the page."))
                        })
                    }
                }
            })
        }else{
            console.log("token is good");
            let i;
            for(i=0;i<this.state.glossaryTerms.length;i++){
                if (this.state.glossaryTerms[i]["guid"] === selectedTermGuid){
                    this.setState({currentRelationshipId:this.state.glossaryTerms[i]["relationshipGuid"]},()=>{
                        // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/terms/"+selectedTermGuid+"/assignedEntities",{
                        fetch(environmentSetUp["deleteGlossaryTermsBaseUrl"][environmentSelection] +selectedTermGuid+"/assignedEntities",{
                            method:"DELETE",
                            headers:{
                                'Authorization':'Bearer ' + this.state.accessToken,
                                'Content-Type': 'application/json'
                            },
                            body:JSON.stringify([{
                                "guid":this.state.guid,
                                "relationshipGuid":this.state.currentRelationshipId
                            }])
                        }).then(alert("The glossary term has been deleted, please refresh the page."))
                    })
                }
            }
        }
    }


    async handleDeleteEntry(){
        console.log("clicked delete")
        console.log(this.state.guid);
        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            console.log("token is bad")
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp["purviewAccessToken"][environmentSelection] )
            const data = await res.json();
            var currentDateTime = new Date();
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                sessionStorage.setItem('accessToken',this.state.accessToken);
                sessionStorage.setItem('expiresOn',this.state.expiresOn);
                // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity/guid/"+this.state.guid,{
                fetch(environmentSetUp["deleteEntityBaseUrl"][environmentSelection] +this.state.guid,{
                    method:"DELETE",
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    },
                    body:JSON.stringify({
                        "guid":this.state.guid
                    })
                }).then(res=>console.log(res.json())).then(
                    this.props.history.push({
                        pathname:'/'
                    })
                )
                alert("The entry selected is deleted, you will be navigated back to the search page.")
            })
        }else{
            console.log("token is good")
            // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity/guid/"+this.state.guid,{
            fetch(environmentSetUp["deleteEntityBaseUrl"][environmentSelection] +this.state.guid,{
                    method:"DELETE",
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    },
                    body:JSON.stringify({
                        "guid":this.state.guid
                    })
                }).then(res=>console.log(res.json())).then(
                    this.props.history.push({
                        pathname:'/'
                    })   
                )
                alert("The entry selected is deleted, you will be navigated back to the search page.")
        }
    }

    async handleSaveChanges(){
        console.log("clicked save!")
        const payload = {
            "referredEntities": {},
            "entity": {
                "typeName": "UN_Manual_Input",
                "attributes": {

                    "name":this.state.name,
                    "Technical_Name":this.state.technicalName,
                    "Entity_ID":this.state.entityID,
                    "Start_Date":this.state.startDate,
                    "Close_Date":this.state.closeDate,
                    "Sensitivity_Level":this.state.sensitivityLevel,
                    "PII":this.state.pii,
                    "Dataset_Owner":this.state.owner,
                    "Point_Of_Contact":this.state.expert,
                    "Point_Of_Contact_Email":this.state.expertEmail,
                    "Organization":this.state.organizationName,
                    "Organization_ID":this.state.organizationID,
                    "Entity":this.state.entityName,
                    "Function":this.state.function,
                    "Description":this.state.description,
                    "Link_To_Data":this.state.linkToData,
                    "Updated_On":"",
                    "Updated_By":"",
                    "Status":this.state.status,
                    "Frequency":this.state.frequency,
                    "Language":this.state.language,
                    "Database_Management_System":this.state.databaseManagementSystem,
                    "UniteApps_ID":"",
                    "qualifiedName":this.state.details.attributes.qualifiedName
                },
                "status": "ACTIVE",
                "createdBy": "Eric Cai",
                "updatedBy": "Eric Cai",
                "version": 1.0
            }
        }
        
        
        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            console.log('token is bad.')
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp["purviewAccessToken"][environmentSelection])
            const data = await res.json();            
            var currentDateTime = new Date();
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
            },()=>{
                    sessionStorage.setItem('accessToken',this.state.accessToken);
                    sessionStorage.setItem('expiresOn',this.state.expiresOn);
                    // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity",{
                    fetch(environmentSetUp["saveChangesBaseUrl"][environmentSelection],{
                        method:"POST",
                        headers:{
                            'Authorization':'Bearer ' + this.state.accessToken,
                            'Content-Type': 'application/json'
                        },
                        body:JSON.stringify(payload)
                    }).then(
                        this.props.history.push({
                            pathname:'/details',
                            search:"guid="+this.state.guid,
                            state:{guid:this.state.guid}
                        })
                    )
                })
        }else{
            console.log('token is good.')
            // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity",{
            fetch(environmentSetUp["saveChangesBaseUrl"][environmentSelection],{
                    method:"POST",
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    },
                    body:JSON.stringify(payload)
                }).then(
                    res=>{
                        console.log(res.json())
                        this.props.history.push({
                            pathname:'/details',
                            search:"guid="+this.state.guid,
                            state:{guid:this.state.guid}
                        })
                    }
                    
                )
        }
        
        
    }

    componentWillMount(){
        if(qs.parse(this.props.location.search)['?guid'] !== undefined){
            // console.log("found param")
            this.setState({
                guid:qs.parse(this.props.location.search)['?guid']
            },()=>{
                // console.log("state set")
                sessionStorage.setItem('guid',this.state.guid)
            })
        }else{
            sessionStorage.setItem('guid',this.state.guid)
        }

        if(this.props.location.state!==undefined){
            if(this.props.location.state.keyword!==undefined ){
                this.setState({keyword:this.props.location.state.keyword})
            }
        }

    }

    async componentDidMount(){

        if (myMSALObj.getAccount() === null){
            myMSALObj.loginRedirect(loginRequest);
          }else{
            sessionStorage.setItem('user',myMSALObj.getAccount().name);
            sessionStorage.setItem('email',myMSALObj.getAccount().userName);
        }
       
        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            console.log('token is bad.')
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp["purviewAccessToken"][environmentSelection])
            const data = await res.json();
            var currentDateTime = new Date();
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                sessionStorage.setItem('accessToken',this.state.accessToken);
                sessionStorage.setItem('expiresOn',this.state.expiresOn);

                // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/49305c01-7a53-4bbb-9def-21e9bd8e1c5c/terms",{
                fetch(environmentSetUp["readGlossaryUrl"][environmentSelection],{
                    method:"GET",
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    }
                }).then(res=>res.json()).then(data=>{
                    this.setState({
                        availableGlossaryTerms:data
                    })
                    
                })


                // fetch(detailsBaseUrl+this.state.guid,{
                fetch(environmentSetUp["detailBaseUrl"][environmentSelection]+this.state.guid,{
                    method: 'GET',
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    }}).then(res=>res.json())
                .then(data=>this.setState({
                    details:data.entity
                },()=>{

                    this.setState({
                        name:this.state.details.attributes.name,
                        technicalName:this.state.details.attributes.Technical_Name,
                        entityID:this.state.details.attributes.Entity_ID,
                        startDate:this.state.details.attributes.Start_Date,
                        closeDate:this.state.details.attributes.Close_Date,
                        sensitivityLevel:this.state.details.attributes.Sensitivity_Level,
                        pii:this.state.details.attributes.PII,
                        owner:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Owner[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Owner[0]["id"]]["name"],
                        expert:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["name"] ,
                        expertEmail:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["email"],
                        organizationName:this.state.details.attributes.Organization,
                        organizationID:this.state.details.attributes.Organization_ID,
                        entityName:this.state.details.attributes.Entity,
                        function:this.state.details.attributes.Function,
                        description:this.state.details.attributes.Description,                      
                        linkToData:this.state.details.attributes.Link_To_Data,
                        updatedOn:this.state.details.attributes.Updated_On,
                        updatedBy:this.state.details.updatedBy,
                        status:this.state.details.attributes.Status,
                        frequency:this.state.details.attributes.Frequency,
                        language:this.state.details.attributes.Language,
                        databaseManagementSystem:this.state.details.attributes.Database_Management_System,
                        qualifiedName:this.state.details.attributes.qualifiedName
                    })

                    if(this.state.details.relationshipAttributes.meanings[0]!==undefined){
                        this.state.details.relationshipAttributes.meanings.map(item=>(
                            this.setState(prevState =>{
                                prevState.glossaryTerms.push({"guid":item.guid,"text":item.displayText,"relationshipGuid":item.relationshipGuid})
                            },()=>{
                                this.state.glossaryTerms.map(item => availableTermGuid.push(item.guid))
                                this.setState({
                                    toggle:!this.state.toggle
                                })
                            })
                        ))
                    }else{
                        this.state.glossaryTerms.push({"guid":"","text":"No glossary terms yet","relationshipGuid":""})
                    }

                    if(this.state.details.attributes.Sensitivity_Level==="PUBLIC"){
                        this.setState({isPublic:true})
                    }else if (this.state.details.attributes.Sensitivity_Level==="CONFIDENTIAL"){
                        this.setState({isConfidential:true})
                    }else if (this.state.details.attributes.Sensitivity_Level==="STRICTLY CONFIDENTIAL"){
                        this.setState({isStrictlyConfidential:true})
                    }else{
                        this.setState({isUnclassified:true})
                    }

                }))
            })
        }else{
            console.log('token is good.')

            // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/49305c01-7a53-4bbb-9def-21e9bd8e1c5c/terms",{
            fetch(environmentSetUp["readGlossaryUrl"][environmentSelection],{
                    method:"GET",
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    }
                }).then(res=>res.json()).then(data=>{
                    this.setState({
                        availableGlossaryTerms:data
                    })
                    
                })

            // const response = await fetch(detailsBaseUrl+this.state.guid,{
            const response = await fetch(environmentSetUp["detailBaseUrl"][environmentSelection]+this.state.guid,{
                method: 'GET',
                headers:{
                    'Authorization':'Bearer ' + this.state.accessToken,
                    'Content-Type': 'application/json'
                }})
            const data = await response.json()
            this.setState({
                details:data.entity
                },()=>{

                    this.setState({
                        name:this.state.details.attributes.name,
                        technicalName:this.state.details.attributes.Technical_Name,
                        entityID:this.state.details.attributes.Entity_ID,
                        startDate:this.state.details.attributes.Start_Date,
                        closeDate:this.state.details.attributes.Close_Date,
                        sensitivityLevel:this.state.details.attributes.Sensitivity_Level,
                        pii:this.state.details.attributes.PII,
                        owner:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Owner[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Owner[0]["id"]]["name"],
                        expert:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["name"] ,
                        expertEmail:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["email"],
                        organizationName:this.state.details.attributes.Organization,
                        organizationID:this.state.details.attributes.Organization_ID,
                        entityName:this.state.details.attributes.Entity,
                        function:this.state.details.attributes.Function,
                        description:this.state.details.attributes.Description,                      
                        linkToData:this.state.details.attributes.Link_To_Data,
                        updatedOn:this.state.details.attributes.Updated_On,
                        updatedBy:this.state.details.updatedBy,
                        status:this.state.details.attributes.Status,
                        frequency:this.state.details.attributes.Frequency,
                        language:this.state.details.attributes.Language,
                        databaseManagementSystem:this.state.details.attributes.Database_Management_System,
                        qualifiedName:this.state.details.attributes.qualifiedName
                    })

                    if(this.state.details.relationshipAttributes.meanings[0]!==undefined){
                        this.state.details.relationshipAttributes.meanings.map(item=>(
                            this.setState(prevState =>{
                                prevState.glossaryTerms.push({"guid":item.guid,"text":item.displayText,"relationshipGuid":item.relationshipGuid})
                            },()=>{
                                this.state.glossaryTerms.map(item => availableTermGuid.push(item.guid))
                                this.setState({
                                    toggle:!this.state.toggle
                                })
                            })
                        ))
                    }else{
                        this.state.glossaryTerms.push({"guid":"","text":"No glossary terms yet","relationshipGuid":""})
                    }

                    if(this.state.details.attributes.Sensitivity_Level==="PUBLIC"){
                        this.setState({isPublic:true})
                    }else if (this.state.details.attributes.Sensitivity_Level==="CONFIDENTIAL"){
                        this.setState({isConfidential:true})
                    }else if (this.state.details.attributes.Sensitivity_Level==="STRICTLY CONFIDENTIAL"){
                        this.setState({isStrictlyConfidential:true})
                    }else{
                        this.setState({isUnclassified:true})
                    }

                } )
        }

    }


    render(){
        if(sessionStorage.getItem("role")!=="curator"){
            return(
                <h2>Not authorized</h2>
            )
        }else{
            if(this.state.details===undefined){
                return(
                 <div className="spinner text-center ">
                     <div className="spinner-border align-middle" role="status">
                         <span className="sr-only">Loading...</span>
                     </div>
                 </div>
                )
            }else{
                console.log(this.state)
                return(
                    <React.Fragment>
                        <NavBar handleLogOut={this.handleLogOut}  handleCreate={this.handleCreate}/>
                        <div className="edit-main">
                            <nav aria-label="breadcrumb w-100" className="mb-4">
                                <ol className="breadcrumb-content breadcrumb bg-light w-100 mr-0 float-left">
                                    <li className="breadcrumb-item small"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item small"><a href={this.state.keyword===""?"/results?keyword=":"/results?keyword="+this.state.keyword}>List</a></li>
                                    <li className="breadcrumb-item small"><a href={"/details?guid="+this.state.guid}>Details</a> </li>
                                    <li className="breadcrumb-item active small">Edit</li>
                                </ol>
                            </nav>
                            <div className="px-3 mx-0">
                                <h1 className="w-100 px-5 mx-2 pb-1 details-title font-weight-bold float-left">
                                    {"Edit: "+this.state.details.attributes.name}    
                                </h1>
                                <div className="mx-2 px-5">
                                    <a href="#details-info" data-toggle="collapse">
                                        <i onClick={this.handleClickInfo} className= {this.state.loadMoreClicked===false?"fas fa-plus-circle fa-sm text-secondary details-info-button":"fas fa-minus-circle fa-sm text-secondary details-info-button"} />
                                    </a>
                                </div>
                                 
                                <div className="collapse mx-2 px-5 w-50" id="details-info" >
                                    <div className="details-timestamp  bg-secondary  border-0 rounded shadow-lg p-3">
                                        <p className="m-0 text-white">
                                            Registerd on: {" " + moment.utc(this.state.details.createTime).local().toLocaleString()}
                                        </p>
                                        <p className="m-0 text-white">
                                            Modified on: {" " + moment.utc(this.state.details.updateTime).local().toLocaleString()}
                                        </p>
                                        <p className="m-0 text-white">
                                            Updated by: {this.state.updatedBy}
                                        </p>
                                    </div>                            
                                </div>
                            </div>

                            <div className="container-fluid row results-main mx-0 pt-1">     
                                <div className="col-9 px-0 mb-3 px-5"> 
                                    <ul className="nav nav-tabs mb-3 px-2">
                                        <li className="nav-item">
                                            <a className="nav-link active content-tab" data-toggle="tab" id="primary-tab" href="#details-content">Details</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link content-tab"  data-toggle="tab" id="secondary-tab" href="#data-content" >Data</a>
                                        </li>
                                    </ul>   
                                    <div className="tab-content">
                                        <div id="details-content" className="tab-pane fade show active">

                                                <div className="w-50 float-left mx-0 mb-2"> 
                                                    <div>
                                                        <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="DATASET TITLE/DATASET NAME">
                                                            name
                                                        </p>
                                                            <input className="form-control form-control-sm w-75 mx-2 mb-2" 
                                                            type="text" 
                                                            defaultValue = {this.state.details.attributes.name}
                                                            autoComplete="off"
                                                            onChange={this.handleChangeName}
                                                            />
                                                    </div>
                                                    
                                                    <div>
                                                        <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Abbreviation of the Entitiy/Department Name">
                                                        entity
                                                        </p>
                                                        <select  className="w-75 mx-2 form-control form-control-sm my-0 py-0" onChange={this.handleClickEntity} >
                                                            {
                                                                entityList.map(item=>{
                                                                    return( <option selected={item===this.state.details.attributes.Entity_ID?true:false}
                                                                                    >{item}</option> )
                                                                })
                                                            }   
                                                        </select> 
                                                        <p className="px-2 py-0 my-0 small text-secondary font-italic">
                                                            Organization: {this.state.organizationName}
                                                        </p>
                                                    </div>

                                                    <div>
                                                        <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Earliest content date inside the dataset" >
                                                        start date
                                                        </p>
                                                        <input type="text" className="mx-2 w-75 form-control form-control-sm  my-0 py-0"  value={moment.unix(this.state.startDate/1000).format('dddd, Do MMMM YYYY')} onFocus={()=>this.setState({showStartDateCalendar:true})} />
                                                        <Calendar className={this.state.showStartDateCalendar === true? "":"hide"}
                                                                    // value={this.state.startDate/1000}
                                                                    onChange={this.handleChangeStartDate} />
                                                    </div>

                                                    <div>
                                                        <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Latest content date inside the dataset" >
                                                        close date
                                                        </p>
                                                        <input type="text" className="mx-2 w-75 form-control form-control-sm my-0 py-0"  value={this.state.closeDate===0?"":moment.unix(this.state.closeDate/1000).format('dddd, Do MMMM YYYY')} onFocus={()=>this.setState({showCloseDateCalendar:true})} />
                                                        <Calendar className={this.state.showCloseDateCalendar === true? "":"hide"}
                                                                    // value={this.state.startDate/1000}
                                                                    onChange={this.handleChangeCloseDate} />
                                                    </div>

                                                    <div>
                                                        <p className="px-2 pt-3 mb-0 text-uppercase text-secondary font-weight-bold" title="Status of data">
                                                        status
                                                        </p>
                                                        <form className="px-2 my-0 py-0" onChange={this.handleChangeStatus} >
                                                            <div className="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="active-radio" name="active" 
                                                                        className="custom-control-input" value="Active"
                                                                        checked={this.state.status==="Active"?true:false} />
                                                                <label className="custom-control-label small" for="active-radio">Active</label>
                                                            </div>
                                                            <div className="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="inactive-radio" name="inactive" 
                                                                        className="custom-control-input" value="Inactive"
                                                                        checked={this.state.status==="Inactive"?true:false} />
                                                                <label className="custom-control-label small" for="inactive-radio">Inactive</label>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    <div>
                                                        <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold">
                                                        function
                                                        </p>
                                                        <select  className="w-75 mx-2 form-control form-control-sm" onChange={this.handleClickFunction} >
                                                            <option disabled selected >--please pick a function--</option>
                                                            {
                                                                functionList.map(item=>{
                                                                    return( <option selected={item===this.state.function?true:false}
                                                                                    >{item}</option> )
                                                                })
                                                            }   
                                                        </select> 
                                                    </div>

                                                    <div>
                                                        <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Language data set is available in">
                                                        language
                                                        </p>
                                                        <select  className="w-75 mx-2 form-control form-control-sm" onChange={this.handleClickLanguage} >
                                                            <option disabled selected >--please pick a language--</option>
                                                            {
                                                                languageList.map(item=>{
                                                                    return( <option selected={item===this.state.language?true:false}
                                                                                    >{item}</option> )
                                                                })
                                                            }   
                                                        </select> 
                                                    </div>

                                                    <div>
                                                        <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Glossary terms that are associated with the asset">Glossary terms</p>   
                                                        <select id="pick-glossary-term" className="w-75 mx-2 mb-2 form-control form-control-sm" onChange={this.handleAddTerm} >
                                                            <option disabled selected >--Select Glossary Terms--</option>
                                                            {
                                                                this.state.availableGlossaryTerms.map(item=>{
                                                                    console.log(availableTermGuid.includes(item.guid))
                                                                    return( <option id={item.guid} disabled={availableTermGuid.includes(item.guid)?true:false} >{item.name}</option> )
                                                                })
                                                            }   
                                                        </select>

                                                        { 
                                                            this.state.glossaryTerms.map(item=>{
                                                                return (
                                                                <p className="pl-2 mb-1 pt-1 glossary-term-edit float-left" >
                                                                    {item.text}
                                                                    <button type="button" className="close ml-2 mt-0 pt-0" aria-label="Close" onClick={this.handleDeleteTerm} >
                                                                        <span id={item.guid} aria-hidden="true" className="close-icon" >&times;</span>
                                                                    </button>
                                                                </p>
                                                                )
                                                            })
                                                        }
                                                    </div>

                                                    
                                                </div>
                                                
                                                <div className="w-50 float-right mx-0 mb-2">
                                            
                                                <div>
                                                    <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="ORIGINAL DATA SET TITLE/NAME">
                                                        technical name
                                                    </p>
                                                    <input  className="form-control form-control-sm w-75 mx-2 mb-2" 
                                                            type="text" 
                                                            defaultValue = {this.state.details.attributes.Technical_Name}
                                                            autoComplete="off"
                                                            onChange={this.handleChangeTechnicalName}
                                                            />
                                                </div>

                                                <div>
                                                    <p className="px-2 pt-3 mb-0 text-uppercase text-secondary font-weight-bold" title="Personal Identifiable Information">
                                                    PII
                                                    </p>
                                                    <form className="px-2 my-0 py-0" onChange={this.handleChangePII} >
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                            <input type="radio" id="piiYes-radio" name="piiYes" 
                                                                    className="custom-control-input" value="YES"
                                                                    checked={this.state.pii==="YES"?true:false} />
                                                            <label className="custom-control-label small" for="piiYes-radio">YES</label>
                                                        </div>
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                            <input type="radio" id="piiNo-radio" name="piiNo" 
                                                                    className="custom-control-input" value="NO"
                                                                    checked={this.state.pii==="NO"?true:false} />
                                                            <label className="custom-control-label small" for="piiNo-radio">NO</label>
                                                        </div>
                                                    </form>
                                                </div>

                                                <div>
                                                    <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Security Classification Level">
                                                    sensitivity level
                                                    </p>
                                                    <div className="px-2" >
                                                        <div className="custom-control custom-radio">
                                                            <input type="radio"
                                                                id="isPublic-radio" 
                                                                name="isPublic" 
                                                                className="custom-control-input" 
                                                                checked={this.state.isPublic}
                                                                onClick={this.handleClickPublic}  />
                                                            <label className="custom-control-label small" for="isPublic-radio">PUBLIC</label>
                                                        </div>
                                                        <div className="custom-control custom-radio">
                                                            <input type="radio" 
                                                                id="isUnclassified-radio" 
                                                                name="isUnclassified" 
                                                                className="custom-control-input" 
                                                                checked={this.state.isUnclassified}
                                                                onClick={this.handleClickUnclassified} />
                                                            <label className="custom-control-label small" for="isUnclassified-radio">UNCLASSIFIED</label>
                                                        </div>
                                                        <div className="custom-control custom-radio">
                                                            <input type="radio" 
                                                                id="isConfidential-radio" 
                                                                name="isConfidential" 
                                                                className="custom-control-input" 
                                                                checked={this.state.isConfidential}
                                                                onClick={this.handleClickConfidential} />
                                                            <label className="custom-control-label small" for="isConfidential-radio">CONFIDENTIAL</label>
                                                        </div>
                                                        <div className="custom-control custom-radio">
                                                            <input type="radio" 
                                                                id="isStrictlyConfidential-radio" 
                                                                name="isStrictlyConfidential" 
                                                                className="custom-control-input" 
                                                                checked={this.state.isStrictlyConfidential}
                                                                onClick={this.handleClickStrictlyConfidential} />
                                                            <label className="custom-control-label small" for="isStrictlyConfidential-radio">STRICTLY CONFIDENTIAL</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Description of the dataset">
                                                        description
                                                    </p>
                                                    <textarea className="mx-2 w-75 form-control form-control-sm my-0 py-0"
                                                            rows="5"
                                                            defaultValue = {this.state.description}
                                                            onChange={this.handleChangeDescription}
                                                            >
                                                    </textarea>
                                                </div>

                                                <div>
                                                    <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="How often is the data refreshed or updated?">
                                                    frequency
                                                    </p>
                                                    <select  className="w-75 mx-2 form-control form-control-sm" onChange={this.handleClickFrequency} >
                                                        <option disabled selected >--please pick a frequency--</option>
                                                        {
                                                            frequencyList.map(item=>{
                                                                return( <option selected={item===this.state.frequency?true:false}
                                                                                >{item}</option> )
                                                            })
                                                        }   
                                                    </select> 
                                                </div>

                                                <div>
                                                    <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="Dataset source">
                                                        back end
                                                    </p>
                                                    <input  className="form-control form-control-sm w-75 mx-2 mb-2" 
                                                            type="text" 
                                                            defaultValue = {this.state.databaseManagementSystem}
                                                            autoComplete="off"
                                                            onChange={this.handleChangeDatabaseManagementSystem}
                                                            />
                                                </div>

                                                <div>
                                                    <div className="w-100 mx-2 mt-5 form-inline">
                                                        <button type="button" title="Please make sure all primary fields are filled"
                                                                disabled={this.state.name!==""&&this.state.technicalName!==""&&this.state.entityID!==""&&this.state.startDate!==""&&this.state.closeDate!==""&&this.state.sensitivityLevel!==""&&this.state.pii!==""&&this.state.owner!==""&&this.state.expert!==""&&this.state.expertEmail!==""&&this.state.organizationName!==""?false:true}
                                                                onClick={this.handleSaveChanges}
                                                                className="btn btn-outline-success btn-sm float-left details-button shadow font-weight-bold m-1"><i className="fas fa-check-circle"></i>   Save</button>
                                                        <button type="button"  title="Delete the current entry"
                                                                className="btn btn-outline-success btn-sm float-left details-button shadow font-weight-bold m-1" 
                                                                onClick={this.handleDeleteEntry}
                                                                ><i className="far fa-trash-alt"></i>   Delete</button>
                                                        <button type="button"  title="Cancel the action"
                                                                className="btn btn-outline-success btn-sm float-left details-button shadow font-weight-bold m-1" 
                                                                onClick={this.handleCancel}
                                                                ><i className="fas fa-ban"></i>   Cancel</button>
                                                    </div>
                                                </div>

                                            </div>

                                            
                                            
                                            
                                        </div>
                                        
                                        <div id="data-content" className="tab-pane fade">

                                            <div>
                                                <p className="px-2 pt-3 mb-1 text-uppercase text-secondary font-weight-bold" title="URL">
                                                link to data
                                                </p>
                                                <input  className="mx-2 form-control form-control-sm w-75" 
                                                            type="text" 
                                                            defaultValue = {this.state.linkToData}
                                                            autoComplete="off"
                                                            onChange={this.handleChangeLinkToData}
                                                            />
                                                
                                            </div>


                                        </div>
                                    </div>

                            </div>
                            <div className="col-1"></div>
                            <div className="col-2">

                                <div className="card mx-0 px-0 pt-0 mt-4 border-0 shadow-lg rounded details-contact-card mb-4">                               
                                    <div className="m-2">
                                    <p className="text-uppercase pl-2 pt-2 mb-0 text-light font-weight-bold">Expert <i title="Expert is the entity who is responsible for maintaining the data asset." className="fas fa-info-circle fa-sm"/></p>
                                    <p className="pl-2 pt-1 mx-2 btn-light btn-sm border-0 shadow font-weight-bold text-center text-secondary">{this.state.expert}</p>
                                    </div>
                                    <div className="m-2">
                                    <p className="text-uppercase pl-2 pt-2 mb-0 text-light font-weight-bold">Owner <i title="Owner is the entity that has the ownership of the data asset." className="fas fa-info-circle fa-sm"/></p>
                                    <p className="pl-2 pt-1 mx-2 btn-light btn-sm border-0 shadow font-weight-bold text-center text-secondary">{this.state.owner}</p>
                                    </div>                                        
                                </div>
                       
                                </div>
                            </div>
                        </div>
                        
                    </React.Fragment>
                    
                )
            }
        }
        
    }

}

export default Edit